@if (backgroundContainerConfig.showTitle) {
    <div class="marquee-header-title">
        @if (isRequiredTitleIcon()) {
            <div class="title-icon">
                @if (checkTitleIcon) {
                    <ms-competition-logo class="icon" [sportId]="titleIcon.sportId" [leagueId]="titleIcon.id" [fallbackIcon]="titleIcon.icon" />
                } @else {
                    <span class="icon" [ngClass]="titleIcon.icon"></span>
                }
            </div>
        }
        <div class="title-text">{{ title }}</div>
    </div>
}
<div class="marquee-header-link">
    @if (globalLinkConfig.visible && globalLink && globalLinkText) {
        <ms-item [href]="globalLink" [tracking]="undefined" (click)="linkClick()">
            <span item-title [innerHtml]="globalLinkText | msTrust: 'html'"></span>
        </ms-item>
    }
</div>
